/* Model */
class NotificationSubscriptionModel extends App.Models.BaseModel {
  modelUrl = 'NotificationSubscription';
}

App.Models.NotificationSubscription = NotificationSubscriptionModel;

/* Collection */
class NotificationSubscriptionCollection extends App.Collections.BaseCollection {
  url = 'NotificationSubscription';
  model = App.Models.NotificationSubscription;
}

App.Collections.NotificationSubscriptions = NotificationSubscriptionCollection;

/* Router */
class NotificationSubscriptionRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'NotificationSubscription';
      const model = App.Models.NotificationSubscription;
      const collectionClass = App.Collections.NotificationSubscriptions;

      super(entityName, model, collectionClass);
  }

  beforeCreate = (model) => {
    if (model.attributes.type === 'SMS') {
      model.attributes.value = model.attributes.value.replace(/\-|\ |\(|\)/g, '');
    }
    model.attributes.channel = 'Live';
  }

  beforeUpdate = (formData) => {
    formData.channel = 'Live';
  }

  afterCreateForm = () => {
    App.Views.NotificationSubscription.addEventListeners();
  }

  beforePopulateForm = () => {
    App.Views.NotificationSubscription.disableFields();
  }

  afterPopulateForm = () => {
    App.Views.NotificationSubscription.changeInputType();
  }
}

App.Routers.NotificationSubscription = NotificationSubscriptionRouter;
